import { render, staticRenderFns } from "./UserPerfil.vue?vue&type=template&id=5021f703&scoped=true&"
import script from "./UserPerfil.vue?vue&type=script&lang=js&"
export * from "./UserPerfil.vue?vue&type=script&lang=js&"
import style0 from "./UserPerfil.vue?vue&type=style&index=0&id=5021f703&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021f703",
  null
  
)

export default component.exports